export const TAGS_INIT_START = 'categories/TAGS_INIT_START';
export const TAGS_INIT_COMPLETED = 'categories/TAGS_INIT_COMPLETED';
export const TAGS_INIT_FAILED = 'categories/TAGS_INIT_FAILED';

export const TAGS_CREATE_COMPLETED = 'categories/TAGS_CREATE_COMPLETED';
export const EDIT_TAGS_COMLETED = 'categories/EDIT_TAGS_COMLETED';

export const UPDATE_TAGS_COMLETED = 'categories/UPDATE_TAGS_COMLETED';
export const REMOVE_TAGS_COMLETED = 'categories/REMOVE_TAGS_COMLETED';
